import { isObject } from 'util';

import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FormAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, {  OnBeforeSubmit, OnCancel, OnMount } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';
import { isContentfulString, isEmptyObject } from '@philips-emr/tws-utils';

import BaseController from './BaseController';

@Controller({ fragment: 'transferir-titularidade' })
class TransferirTitularideController extends BaseController {

  @Inject('form-alterar-titular')
  private formDados: FormAPI;
  @Inject('fetch-alterar-titular')
  private fetchTitular: FetchAPI;
  
  @OnMount({ target: 'form-alterar-titular' })
  onMountForm(): void {
    const {  nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqTitular : nrSeqBeneficiario, nrSeqContrato });

    void HttpService.get<Record<string, Value>>(Endpoint.GET.TITULAR_PROCESSO_MIGRACAO, { nrSeqTitular : nrSeqBeneficiario, nrSeqContrato  })
      .then(response => {

        const { body: solicAberta } = response;

        if (!solicAberta) {
          this.executaConsultaTitular();
          return;
        }

        const { nrSeqSolicAlt, nrSeqTitularContrato :nrSeqTitularNovo } = solicAberta;
        this.context.set({ nrSeqSolicAlt, nrSeqTitularNovo });
        this.fetchTitular.setParameters({ nrSeqBeneficiario });
        this.fetchTitular.forceFetch();
      });
  }

  @OnBeforeSubmit({ target: 'form-alterar-titular' })
  onBeforeSubmit(event: AbortableSubmitEvent): void {
    const dados = this.formDados.getRecord();
    const { nrSeqGrupoContratoWeb, nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { nrSeqSolicAlt } = this.context.getBulkData();
    const nrSeqTitular = nrSeqBeneficiario;
    const body = { ...dados, nrSeqSolicAlt, nrSeqTitular, nrSeqContrato };

    HttpService.post(Endpoint.POST.TRANSFERIR_TITULARIDADE, { nrSeqBeneficiario, nrSeqContrato }, { body })
      .then(() => {
        ToastServiceStipulator.success(msg('stipuplator.alteracao.solicitada'));
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
      }).catch(response => {
        this.formDados.setEditing(true);
        const openToast = (msg: string): void => {
          ToastServiceStipulator.warning(msg);
        };

        const { body } = response;

        if (isObject(body) && !isEmptyObject(body)) {
          return openToast(body[Object.keys(body)[0]]);
        }

        if (isContentfulString(body)) {
          return openToast(body);
        }
        event.abort();
      });
  }

  @OnCancel({ target: 'form-alterar-titular' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  private executaConsultaTitular(): void {
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    this.fetchTitular.forceFetch();
  }

}
export default TransferirTitularideController;
